var parameterInsert={  
    IdDocListSelect:'',
    Text:'',
    Value:'', 
    Active:'1',
    User:'',
    IP:'', 
    BaseIdDocListSelectValue:'0',
    IsSendEmail:2
} 
var parameterUpdate={
    IdDocListSelectValue:'', 
    Text:'',
    Value:'',  
    Active:'1',
    User:'',
    IP:'',
    IsSendEmail:2
} 
var parameterView={ 
    IdDocListSelect:'',
    Text:'',
    Value:'',
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}